import React, { useState, useRef, useCallback, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Form, {
    Item,
    Label,
    ButtonItem,
    ButtonOptions,
    RequiredRule,
    CustomRule,
    EmailRule
} from 'devextreme-react/form';
import notify from 'devextreme/ui/notify';
import LoadIndicator from 'devextreme-react/load-indicator';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/auth';
import axios from 'axios';
import { backendlink } from '../../config';
import { Toast } from 'devextreme-react/toast';

export default function DoctorPatientAddForm() {
    const { user } = useAuth();

    const navigate = useNavigate();

    const [users, setUsers] = useState([]);

    const location = useLocation();

    const [loading, setLoading] = useState(false);
    const [formData, setformData] = useState({ name: '', linkedCustomerToken: '', linkedCustomerName: '', address: '', contactPerson: '', email: '', phone: '', loginEmail: '', status: true });
    const formDataRef = useRef(null)

    const [toastConfig, setToastConfig] = useState({
        isVisible: false,
        type: 'success',
        message: '',
    });

    function onHiding() {
        setToastConfig({
            ...toastConfig,
            isVisible: false,
        });
    }

    const onSubmit = async (e) => {
        e.preventDefault();

        if (!validateEmail(formData.email)) {
            setToastConfig({
                ...toastConfig,
                isVisible: true,
                type: 'error',
                message: "Email format error",
            });
        } else if (!validateEmail(formData.loginEmail)) {
            setToastConfig({
                ...toastConfig,
                isVisible: true,
                type: 'error',
                message: "Login Email format error",
            });
        } else {
            setLoading(true);

            try {
                const response = await axios.post(backendlink + 'doctor/createpatient',
                {
                    usertoken: user.userToken,
                    name: formData.name,
                    description0: formData.address,
                    description1: formData.contactPerson,
                    email: formData.email,
                    phone: formData.phone,
                    username: formData.loginEmail,
                    password: formData.password,
                    confirmPassword: formData.confirmPassword,
                    isEnabled: formData.status
                }, 
                {
                    headers: {
                        token: user.token
                    }        
                }).then((res)=>{
                    setLoading(false);

                    if (res.data.errorno == 0){
                        setToastConfig({
                            ...toastConfig,
                            isVisible: true,
                            type: 'success',
                            // message: 'New partner has been added',
                            message: 'Patient created',
                        });    

                        setformData({ name: '', address: '', contactPerson: '', email: '', phone: '', loginEmail: '', status: true })
                    } else{
                        setToastConfig({
                            ...toastConfig,
                            isVisible: true,
                            type: 'error',
                            message: res.data.errmessage,
                        });    
                    }
                });
            } catch (error) {
                setLoading(false);
                alert(error);
            }
        }
    };

    const validateEmail = (email) => {
        return String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    };

    useEffect(() => {
        setformData({ name: '', address: '', contactPerson: '', email: '', phone: '', loginEmail: '', status: true })
    }, [user]);

    const passwordOptions = { mode: "password" };
    const readonlyptions = { readOnly: 'true' };

    var statusItems = [
        { id: true, text: 'Active'},
        { id: false, text: 'Inactive'},
    ];

    return (
        <form onSubmit={onSubmit}>
            <Form formData={formData} ref={formDataRef} disabled={false}>

                <Item
                    dataField={'name'}
                    editorType={'dxTextBox'}
                >
                    <Label text='Patient Name' />
                </Item>

                <Item
                    dataField={'address'}
                    editorType={'dxTextBox'}
                >
                    <Label text='Address' />
                </Item>

                <Item
                    dataField={'contactPerson'}
                    editorType={'dxTextBox'}
                >
                    <Label text='Contact Person' />
                </Item>

                <Item
                    dataField={'phone'}
                    editorType={'dxTextBox'}
                >
                    <Label text='Phone Number' />
                </Item>

                <Item
                    dataField={'email'}
                    editorType={'dxTextBox'}
                >
                    <Label text='Contact Email' />
                </Item>

                <Item
                    dataField={'loginEmail'}
                    editorType={'dxTextBox'}
                >
                    <Label text='Login Email' />
                </Item>

                <Item
                    dataField={'password'}
                    editorType={'dxTextBox'}
                    editorOptions={passwordOptions}
                >
                    <Label text='Password' />
                </Item>

                <Item
                    dataField={'confirmPassword'}
                    editorType={'dxTextBox'}
                    editorOptions={passwordOptions}
                >
                    <Label text='Confirm Password' />
                </Item>

                <Item
                    dataField={'status'}
                    editorType={'dxSelectBox'}
                    editorOptions= {{
                        items: statusItems,
                        displayExpr: 'text',
                        valueExpr: 'id'
                    }}
                >
                    <Label text='Status' />
                </Item>

                <ButtonItem>
                    <ButtonOptions
                        width={'100%'}
                        type={'default'}
                        useSubmitBehavior={true}
                    >
                        <span className="dx-button-text">
                        {
                            loading
                            ? <LoadIndicator width={'24px'} height={'24px'} visible={true} />
                            : ('Add New Patient')
                        }
                        </span>
                    </ButtonOptions>
                </ButtonItem>
            </Form>

            <Toast
                visible={toastConfig.isVisible}
                message={toastConfig.message}
                type={toastConfig.type}
                onHiding={onHiding}
                displayTime={2000}
            />
        </form>
    )
}
